import styled from 'styled-components';
import closeIcon from 'assets/img/close-icon.svg';
import {
  Modal, ModalHeader, ModalFooter, ModalBody,
} from 'reactstrap';
import { colors, fonts } from 'stylesheets';

export const ModalStyled = styled(Modal)`
  display: flex;
  height: 90vh;
  justify-content: center;
  align-items: center;
  max-width: none !important;
  .modal-content {
    width: ${({ width }) => width || '700px'};
    height: ${({ height }) => height || 'auto'};
    background-color: ${({ backgroundcolor }) => backgroundcolor || 'none'};
    background-clip: ${({ backgroundclip }) => backgroundclip || 'none'};
  }

  .modal-header .close {
    ${({ disabled_close_button }) => disabled_close_button && 'display: none;'};
  }
`;

export const Header = styled(ModalHeader)`
  border-bottom: ${({ borderbottomheader }) => borderbottomheader || `2px solid ${colors.greyLighter}`};
  padding: ${({ paddingheader }) => paddingheader || 'none'};
  height: 50px;

  .modal-title{
    display: flex;
    justify-content: ${({ no_space_between }) => (no_space_between ? '' : 'space-between')};
  }

  h5 {
    font: ${({ font_size_header }) => font_size_header || 16}px ${fonts.secondary};
    text-transform: ${({ text_transform }) => text_transform || 'uppercase'};
    font-weight: ${({ bold_header }) => (bold_header ? 700 : 500)};
    text-align: ${({ text_aling_header }) => text_aling_header || 'center'};
    display: block;
    width: 100%;
  }
  button {
    position: absolute;
    right: ${({ modallist }) => (modallist ? '48' : '28')}px;
    top: ${({ modallist }) => (modallist ? '46' : '26')}px;
    background: url(${closeIcon}) no-repeat center;
    &:active,
    &:focus {
      outline: none;
      border: none;
    }
    span {
      display: none;
    }
  }
`;

export const Body = styled(ModalBody)`
  padding: ${({ padding }) => padding || '40px 60px'};
  overflow: ${({ overflow }) => overflow || 'auto'};
  max-height: 85vh;
  p {
    font: 14px ${fonts.secondary};
    color: ${colors.greyDark};
    text-align: center;
  }
`;

export const Footer = styled(ModalFooter)`
  height: 47px;
  padding: 0px;
  border: none;
  button {
    border: none;
    border-radius: 0px;
    height: 47px;
    width: 100%;
    background: ${colors.primary};
    font: 16px ${fonts.secondary};
    text-transform: uppercase;
    font-weight: 500;
    cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
    &:active,
    &:focus {
      outline: none;
      background: darken(${colors.primary}, 5%);
      border: none;
      box-shadow: none;
    }
  }
`;

export const BackButton = styled.img`
  width: 15px;
  height: 15px;
  cursor: pointer;
  margin-right: 20px;
`;
